<app-breadcrumb [master]="'Struktura sieci'" [parentName]="'Dokumenty'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Dane">
    <app-document-details-view *ngIf="!modify" [document]="document" (modifyClicked)="modify = true"></app-document-details-view>
    <app-document-add *ngIf="modify" [document]="document" (closeModification)="modify = false; loadDocument()"></app-document-add>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [document]="document"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
